import { parseEntityItemId } from '@wix/a11y-rules';
import { assertNotOptional } from '@wix/seo-common-core';
import _ from 'lodash';
import { modify } from 'ricos-content/libs/modify';
import { EventImageType } from '../../fetch-events';
import { buildSingleNode } from '../../utils/build-single-rich-content-node';
const FIELD_MASK = {
  DESCRIPTION: 'description',
  MAIN_IMAGE: 'mainImage'
};
export const buildEventsBulkUpdatePayload = (altTextData, eventsMap) => {
  const payload = [];
  const updatesByEventId = _.groupBy(altTextData.map(_ref => {
    let {
      id,
      alt,
      entityId
    } = _ref;
    const event = eventsMap.get(entityId ?? '');
    assertNotOptional(event);
    const eventId = event.id;
    const imageType = id === eventId ? EventImageType.MAIN_IMAGE : EventImageType.DESCRIPTION;
    if (imageType === EventImageType.MAIN_IMAGE) {
      return {
        alt,
        entityId: eventId,
        imageId: id,
        isMain: true
      };
    }
    const {
      itemId: imageId,
      entities
    } = parseEntityItemId(id, 2);
    return {
      alt,
      entityId: eventId,
      imageId,
      isMain: false,
      nodeId: entities.length > 1 ? entities[1] : ''
    };
  }), upd => upd.entityId);
  Object.entries(updatesByEventId).forEach(_ref2 => {
    let [eventId, updatesForEvent] = _ref2;
    if (!eventId) {
      return;
    }
    const originalEvent = eventsMap.get(eventId);
    if (!originalEvent) {
      return;
    }
    const fieldMask = [];
    const updatedEvent = {
      id: eventId
    };
    const descriptionToUpdate = updateRichContent(originalEvent, updatesForEvent.filter(upd => !upd.isMain));
    if (descriptionToUpdate) {
      updatedEvent.description = descriptionToUpdate;
      fieldMask.push(FIELD_MASK.DESCRIPTION);
    }
    const mainImageToUpdate = updatesForEvent.find(upd => upd.isMain);
    if (mainImageToUpdate) {
      updatedEvent.mainImage = {
        ...originalEvent.mainImage,
        altText: mainImageToUpdate.alt
      };
      fieldMask.push(FIELD_MASK.MAIN_IMAGE);
    }
    payload == null || payload.push({
      event: updatedEvent,
      fieldMask
    });
  });
  return payload;
};
const updateRichContent = (originalEvent, updatesForEvent) => {
  var _description$nodes;
  const description = originalEvent == null ? void 0 : originalEvent.description;
  const updatesByNodeId = _.groupBy(updatesForEvent, upd => upd.nodeId);
  if (!(description != null && (_description$nodes = description.nodes) != null && _description$nodes.length)) {
    return null;
  }
  return modify(description).filter(node => Object.keys(updatesByNodeId).includes(node.id)).set(node => buildSingleNode(node, updatesByNodeId[node.id]));
};
//# sourceMappingURL=bulk-update-events-alt-text-payload-builder.js.map